<div class="flex flex-col gap-4">
  @if(isLoading()){
  <app-skeleton-match-summary class="flex flex-col gap-4" />
  <app-skeleton-match-incidents />
  } @else {

  <!-- <div nz-row>
    <a
      [href]="youtuveLink()"
      rel="noopener noreferrer"
      target="_blank"
      nz-col
      nzSpan="24"
    >
      <div
        class="flex gap-5 px-5 py-4 cursor-pointer max-sm:gap-3 bg-grey-5 rounded-5"
      >
        <div
          class="max-w-[146px] max-sm:max-w-[100px] w-full h-[146px] max-sm:h-[100px] bg-white rounded-full flex justify-center items-center"
        >
          <img
            alt="competitionLogo"
            class="max-w-[90px] h-[90px] max-sm:max-w-[60px] max-sm:h-[60px]"
            [src]="getCompetitionLogo()"
          />
        </div>
        <div class="flex flex-col py-3 leading-tight font-roboto-600">
          <div class="text-24 max-sm:text-18">
            {{ getTitle() }}
          </div>
          <div class="text-20 max-sm:text-16">
            {{ getCompetitionName() }}
          </div>

          <img
            alt="youtube"
            [src]="getYoutubeLogo()"
            class="max-w-[110px] w-full mt-auto"
          />
        </div>
      </div>
    </a>
  </div> -->

  <app-livetracker [matchIdProp]="tsExternalMatchId()" />

  @if(matchIncidents().FirstHalfIncidents.length>0){

  <app-incidents [incidents]="matchIncidents()" />
  } @else {
  <div
    class="p-4 my-4 text-center bg-white font-roboto-700 text-blue-o-50 max-sm:p-3 rounded-6 max-sm:my-2"
  >
    {{ "NotAvalaibleInformation" | translate }}
  </div>
  } }
</div>
